<template>
	<div
		id="profiles"
		class="w-full"
	>
		<div class="btn-pills-group">
			<button
				class="btn btn-pill"
				id="profile_1"
				:class="{
					off: !profiles.profile_1,
					active: selectedProfile === 'profile_1',
				}"
				@click="SelectProfile('profile_1')"
			>
				F1
			</button>
			<button
				class="btn btn-pill"
				id="profile_2"
				:class="{
					off: !profiles.profile_2,
					active: selectedProfile === 'profile_2',
				}"
				@click="SelectProfile('profile_2')"
			>
				F2
			</button>
			<button
				class="btn btn-pill"
				id="profile_3"
				:class="{
					off: !profiles.profile_3,
					active: selectedProfile === 'profile_3',
				}"
				@click="SelectProfile('profile_3')"
			>
				F3
			</button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ProfileBar',
		props: {
			profiles: {
				type: Object,
				default: () => ({}),
			},
			selectedProfile: {
				type: String,
				default: 'current_profile',
			},
		},
		methods: {
			SelectProfile(profile) {
				this.$emit('select-profile', profile)
			},
		},
	}
</script>

<style lang="scss" scoped>
	#profiles {
		height: 4rem;
		padding: 0.375rem 1rem 0;
		margin-bottom: 0.75rem;
		border-bottom: 1px solid var(--elementsBorderColor);
		display: flex;
		align-items: center;

		.btn-pills-group {
			.btn-pill {
				&.active {
					background-color: var(--pendingActiveBackgroundColor);
					border-color: var(--pendingActiveBackgroundColor);
					color: var(--pendingActiveColor);

					&::before {
						content: '';
						height: 0;
						width: 0;
						background-color: var(--pendingActiveBackgroundColor);
						border-radius: 50%;
						position: absolute;
						top: -7px;
						right: -9px;
						z-index: 10;
					}
				}
			}
		}
	}
</style>
